import React from 'react';
import { useTranslation } from 'react-i18next';
import profilepic from '../../../assets/profile_pic.webp';
import { Container, Profile, Infos } from './styles';

export default function MainSection() {
  const { t } = useTranslation();

  return (
    <Container>
      <Profile src={profilepic} alt="profile_pic" width="100%" height="100%" />
      <Infos>
        <h3>{t('hello')}</h3>
        <h1>Cristofer Gadens</h1>
        <div className="texts">
          <span>{t('i_am')}</span>
          <h2> Frontend Developer</h2>
        </div>
      </Infos>
    </Container>
  );
}
